<template>
  <div class="form-group integration_fields" id="egoi-integration">
    <label>{{ $t('account.editModal.eGoi.apiKey') }}</label>
    <input name=''
           class="form-control"
           :placeholder="$t('account.editModal.eGoi.apiKey')"
           :value="apiKey"
           @change="setEmailServiceConfig">
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  methods: {
    setEmailServiceConfig(event) {
      const target = event.target;
      const { value, name } = target;

      this.setConfig({
        key: name,
        value,
      });
    },
    ...mapActions({
      setConfig: 'account/setConfig',
    }),
  },
  computed: {
    ...mapGetters({
      apiKey: 'account/apiKey',
    }),
  },
};
</script>



// WEBPACK FOOTER //
// EGoi.vue?0ba9bcfb